import {MultiSelectProps} from '../components/multi-select';

export const getMultiSelect =
  <T>(data: Omit<MultiSelectProps<T>, 'type'>) =>
  (): MultiSelectProps<T> => ({
    ...data,
    type: 'multi-select',
  });
